"use strict";const e=require("./_commonjsHelpers.js"),r=require("../node_modules/prop-types/index.js");var s=r.__require();const o=e.getDefaultExportFromCjs(s);module.exports=o;
//# sourceMappingURL=index.js.map
